export const externalLinks = {
    faceBook: 'https://www.facebook.com/pg/jelenascake.co.uk',
    instagram: 'https://instagram.com/jelenas_cake_ltd',
    googleReviews: 'https://maps.app.goo.gl/xz3Be1a8e5wg9ycg8?g_st=com.google.maps.preview.copy'
}